import * as z from "zod";
import { zql } from "../generatedDrizzleSchema";
import { mutator } from "./mutator";

export const closePersonalChatSchema = z.object({
  id: z.string(),
});

export const closePersonalChat = mutator({
  schema: closePersonalChatSchema,
  resolve: {},
  permissions: {
    none: "personal chats are read and written only for ctx.userId",
  },
  fn: async ({ tx, ctx, args }) => {
    const { userId } = ctx;
    const [pc] = await tx.run(
      zql.personalChats.where("id", args.id).where("userId", userId)
    );
    if (!pc) return;
    await tx.mutate.personalChats.update({
      id: args.id,
      closedAt: Date.now(),
    });
  },
});
